<div style="text-align: center;">
    <div>
        <i class="pi pi-info-circle" style="font-size: 3em; color: #4EA294 !important; "></i>
    </div>
    <div>
    <p-editor [(ngModel)]="message" [readonly]="true" [style]="{height: '150px'}"></p-editor>
    </div>
</div>
<div class="ui-dialog-buttonpane ui-helper-clearfix" style="margin-top: 32px; text-align: center;">
    <button pButton icon="pi pi-check" (click)="accept()" label="{{'general.action.apply' | translate}}"
        style="margin-right: 64px;"></button>
    <button pButton class="p-button-secondary" icon="pi pi-times" (click)="reject()"
        label="{{'general.action.cancel' | translate}}"></button>
</div>